// extracted by mini-css-extract-plugin
export default {"container":"dc_d","linkContainer":"dc_lw","innerContainer":"dc_dx","titleWrapper":"dc_jZ","title":"dc_c0","chevron":"dc_hp","anchorContainer":"dc_lx","description":"dc_cM"};